import React, { useState, useEffect, useRef } from 'react';
import '../styles/VideoPlayer.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const videos = [



    
    {
        type: 'image',
        src: '/images/1.jpeg?v=20260925',
        text: 'Hoş geldin! Bizleri daha yakından tanımak ister misin?',
        button: 'Hakkımızda',
        link: '/about',
    },
    {
        src: '/videos/4.mp4',
        text: 'Özgeçmişini tamamla, bu ekibin bir parçası ol. Fırsatlar seni bekliyor!',
        button: 'Hemen Başvur',
        link: '/ozgecmisim',
    },
    {
        src: '/videos/3.mp4',
        text: 'Fulla Moda’da seni bekleyen kariyer yolculuğunu şimdi keşfet.',
        button: 'Kariyer Fırsatlarını Gör',
        link: '/joblist',
    },
];

const VideoPlayerWeb = ({ openLoginPopup }) => {
    const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
    const [touchStartX, setTouchStartX] = useState(0);
    const [touchEndX, setTouchEndX] = useState(0);
    const videoRef = useRef(null);
    const navigate = useNavigate();

    const current = videos[currentVideoIndex];

    useEffect(() => {
        if (current.type !== 'image' && videoRef.current) {
            videoRef.current.play().catch(() => { });
        }
    }, [currentVideoIndex]);

    useEffect(() => {
        if (current.type === "image") {
            const timer = setTimeout(() => {
                handleNext();
            }, 4000); // 3 saniye sonra geç
            return () => clearTimeout(timer);
        }
    }, [currentVideoIndex]);

    const handleNext = () => {
        setCurrentVideoIndex((prev) => (prev + 1) % videos.length);
    };

    const handleSwipe = () => {
        if (touchStartX - touchEndX > 50) handleNext();
        else if (touchEndX - touchStartX > 50) {
            setCurrentVideoIndex((prev) => (prev - 1 + videos.length) % videos.length);
        }
    };

    const handleButtonClick = async () => {
        if (current.button === 'Hemen Başvur') {
            const token = localStorage.getItem('token');
            if (!token) return openLoginPopup ? openLoginPopup() : navigate('/login');
            try {
                const token = localStorage.getItem('token');
                const res = await axios.get(`https://api.fulla.com.tr/api/Auth/GetUserIdByToken`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (res.status === 200) navigate(current.link);
                else openLoginPopup ? openLoginPopup() : navigate('/login');
            } catch {
                openLoginPopup ? openLoginPopup() : navigate('/login');
            }
        } else {
            navigate(current.link);
        }
    };

    return (
        <div
            className="video-container"
            onTouchStart={(e) => setTouchStartX(e.targetTouches[0].clientX)}
            onTouchEnd={(e) => {
                setTouchEndX(e.changedTouches[0].clientX);
                handleSwipe();
            }}
        >
            {current.type === 'image' ? (
                <img src={current.src} alt="Görsel" className="video static-image" />
            ) : (
                <video
                    ref={videoRef}
                    key={currentVideoIndex}
                    src={current.src}
                    autoPlay
                    muted
                    playsInline
                    loop={false}
                    onEnded={handleNext}
                    className="video"
                    disablePictureInPicture
                    controlsList="nodownload nofullscreen noplaybackrate"
                />
            )}

            {current.text && (
                <div className="video-overlay">
                    <h1>{current.text}</h1>
                    <button onClick={handleButtonClick}>{current.button}</button>
                </div>
            )}

            <div className="video-pagination">
                {videos.map((_, index) => (
                    <span
                        key={index}
                        className={`dot ${index === currentVideoIndex ? 'active' : ''}`}
                        onClick={() => setCurrentVideoIndex(index)}
                    ></span>
                ))}
            </div>
        </div>
    );
};

export default VideoPlayerWeb;
